import axios from 'axios';

const api = axios.create({ baseURL: 'https://api.duoultimate.com.br' });

export default api;
